export var mutations = {
    setLoading: function (s, loading) { return s.loading = loading; },
    setCities: function (s, cities) { return s.cities = cities; },
    setCitiesInUse: function (s, cities) { return s.citiesInUse = cities; },
    prependCity: function (s, city) {
        var index = s.cities.findIndex(function (item) { return item.id === city.id; });
        if (index >= 0) {
            s.cities[index] = city;
        }
        else {
            s.cities.unshift(city);
        }
    },
};
